export default __webpack_public_path__ + "static/media/Captain's Belt of the Watchtowers.c3634d92.jpg";